import styled from 'styled-components';

export const Flex1 = styled.div`
  flex: 1;
`;

export const MailageInfo = styled.div`
  height: 125px;
  display: flex;
  background: ${({ theme }) => theme.palette.white};

  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: ${({ theme }) => theme.spacing.x2};
  @media (max-width: ${({ theme }) => theme.media.md}) {
    flex-direction: column;
    height: 16rem;
  }
`;
export const MailageInfoMain = styled(Flex1)`
  margin-inline-end: ${({ theme }) => theme.spacing.x2};
  display: flex;
  flex-direction: column;
`;
export const MailageInfoHead = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.x5};
`;
export const MailageInfoHeadTitle = styled.span`
  font-weight: bold;
  letter-spacing: 1px;
`;

export const MailageInfoMainContainer = styled(Flex1)`
  display: flex;
`;
export const MailageInfoMainBar = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.spacing.x3};
  background: ${({ theme }) => theme.palette.whiteGray};
  border-radius: ${({ theme }) => theme.rounded.x2};
  align-self: flex-end;
  position: relative;
  margin: ${({ theme }) => `0 ${theme.spacing.x3} ${theme.spacing.x2}`};
`;
export const MailageInfoMainTier = styled.div<{ $type? }>`
  position: absolute;
  bottom: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: ${({ theme }) => theme.spacing.x4};

  &.classic {
    & > * {
      color: ${({ theme }) => theme.palette.purple};
    }
  }
  &.silver {
    @media (max-width: ${({ theme }) => theme.media.xs}) {
      padding: ${({ theme }) => `0 ${theme.spacing.x4}`};
    }
    & > * {
      color: ${({ theme }) => theme.palette.darkGray};
    }
  }

  &.gold {
    @media (max-width: ${({ theme }) => theme.media.xs}) {
      padding: ${({ theme }) => `0 ${theme.spacing.x4}`};
    }
    & > * {
      color: ${({ theme }) => theme.palette.gold};
    }
  }

  &.vip {
    & > * {
      color: ${({ theme }) => theme.palette.deepPurple};
    }
  }
`;

export const MailageInfoMainSpan = styled.span<{ $type }>`
  height: ${({ theme }) => theme.spacing.x3};
  background: ${({ theme }) => theme.palette.darkGray};
  position: absolute;
  max-width: 100%;
  border-radius: ${({ theme }) => theme.rounded.x2};
`;
